import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface ICustomFieldLayout {
  isMobile?: boolean;
}

export const CustomFieldLayout: React.FC<ICustomFieldLayout> = ({ isMobile, children }) => (
  <div className={classNames(styles['root'], { [styles['mobile']]: isMobile })}>{children}</div>
);

CustomFieldLayout.displayName = 'CustomFieldLayout';
